import React from 'react'
import styles from './Textarea.module.css'

export const Textarea = ({ name, type, label, placeholder, value, onChange, onBlur }) => {
  return (
    <div >
      <label htmlFor={name}>{label}</label>
      <textarea className={styles.textarea} name={name} type={type} placeholder={placeholder} value={value} onChange={onChange} onBlur={onBlur} />
    </div>
  )
}
